const weburl =  'http://hqyy.tzpdg.top/image';//zs
export default
{
 weburl
}
